(() => {
  const ready = new WeakSet();
  const root = document.body.dataset.root || '/';
  const money = (cents) => new Intl.NumberFormat(document.body.dataset.locale || 'en-US', {style: 'currency', currency: document.body.dataset.currency || 'USD'}).format(cents / 100);
  const notify = (text) => {const toast = document.querySelector('[data-toast]'); if (!toast) return; toast.textContent = text; toast.hidden = false; clearTimeout(toast.timer); toast.timer = setTimeout(() => {toast.hidden = true;}, 3500);};
  function initialize(scope = document) {
    scope.querySelectorAll('[data-dj-product]').forEach((container) => {
      if (ready.has(container)) return;
      ready.add(container);
      const variants = JSON.parse(container.querySelector('[data-product-variants]').textContent);
      const config = JSON.parse(container.querySelector('[data-product-config]').textContent);
      const form = container.querySelector('[data-dj-buy]');
      const select = container.querySelector('[data-variant-select]');
      const button = container.querySelector('[data-add-button]');
      const selectedVariant = () => variants.find(v => String(v.id) === String(form.elements.id.value));
      const update = () => {
        const variant = selectedVariant();
        if (!variant) return;
        container.querySelector('[data-variant-price]').textContent = money(variant.price);
        const unit = container.querySelector('[data-unit-price]');
        unit.textContent = config.sticks > 0 ? `${money(Math.round(variant.price / config.sticks))} / ${config.unitLabel}` : '';
        button.disabled = !variant.available;
        button.textContent = variant.available ? button.dataset.addLabel + ' ↗' : button.dataset.soldLabel;
        if (variant.featured_image && variant.featured_image.src) {
          const image = container.querySelector('.dj-product-main-image');
          if (image) {image.src = variant.featured_image.src; image.removeAttribute('srcset'); image.alt = variant.featured_image.alt || image.alt;}
          container.querySelectorAll('[data-image-url]').forEach(thumb => thumb.setAttribute('aria-pressed', String(new URL(thumb.dataset.imageUrl).pathname === new URL(variant.featured_image.src).pathname)));
        }
        if (select) {const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);}
      };
      if (select) select.addEventListener('change', update);
      container.querySelectorAll('[data-image-url]').forEach(thumb => thumb.addEventListener('click', () => {
        const image = container.querySelector('.dj-product-main-image');
        if (!image) return;
        image.src = thumb.dataset.imageUrl;
        image.removeAttribute('srcset');
        image.alt = thumb.dataset.imageAlt;
        container.querySelectorAll('[data-image-url]').forEach(t => t.setAttribute('aria-pressed', String(t === thumb)));
      }));
      form.addEventListener('submit', async event => {
        if (!window.fetch) return;
        event.preventDefault();
        const variant = selectedVariant();
        if (!variant || !variant.available) return;
        const feedback = container.querySelector('[data-form-feedback]');
        const text = feedback.querySelector('[data-feedback-text]');
        feedback.hidden = true;
        button.disabled = true;
        button.textContent = button.dataset.busyLabel;
        try {
          const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Accept': 'application/json'}, body: new FormData(form)});
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : feedback.dataset.errorLabel);
          feedback.dataset.error = 'false';
          text.textContent = feedback.dataset.successLabel;
          feedback.querySelector('a').hidden = false;
          feedback.hidden = false;
          notify(feedback.dataset.successLabel);
          try {const cart = await fetch(root + 'cart.js').then(r => r.json()); document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);} catch {}
        } catch (error) {
          feedback.dataset.error = 'true';
          text.textContent = error.message || feedback.dataset.errorLabel;
          feedback.querySelector('a').hidden = true;
          feedback.hidden = false;
        } finally {button.disabled = !variant.available; button.textContent = variant.available ? button.dataset.addLabel + ' ↗' : button.dataset.soldLabel;}
      });
    });
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {const menu = document.getElementById(toggle.getAttribute('aria-controls')); const expanded = toggle.getAttribute('aria-expanded') !== 'true'; toggle.setAttribute('aria-expanded', String(expanded)); menu.hidden = !expanded;}
    const step = event.target.closest('[data-quantity-step]');
    if (step) {const input = step.closest('.dj-quantity').querySelector('input'); const next = Math.max(Number(input.min) || 1, (Number(input.value) || 1) + Number(step.dataset.quantityStep)); input.value = next; input.dispatchEvent(new Event('change', {bubbles: true}));}
  });
  document.addEventListener('keydown', event => {if (event.key !== 'Escape') return; document.querySelectorAll('[data-menu-toggle]').forEach(toggle => {toggle.setAttribute('aria-expanded', 'false'); document.getElementById(toggle.getAttribute('aria-controls')).hidden = true;});});
  initialize();
  document.addEventListener('shopify:section:load', () => initialize());
})();
